export const neuralNetworkProgramming = {
  id: 2,
  title: "Neural Network Programming",
  activityId: 3,
  startDate: '2021-04-01',
  endDate: '2021-07-31',
  description: "Built a Java-based neural network from scratch for bit pattern prediction, implementing backpropagation and optimizing training performance over 4 months.",
  categorizedSkills: {
    profession: [
      { name: "Software Development", weight: 1 },
      { name: "AI", weight: 1 },
      { name: "Machine Learning", weight: 0.9 },
      { name: "Neural Networks", weight: 0.9 },
      { name: "Backpropagation", weight: 0.8 }
    ],
    language: [
      { name: "Java", weight: 1 }
    ],
    tools: [],
    lead: []
  },
  goal: "Develop a custom neural network implementation for bit pattern prediction using pure Java",
  detailsFile: "neural-network-programming.md", // Reference to markdown file
  metrics: [],
  role: "Student Software Engineer",
  teamSize: "1",
  git: "not available",
  link: "not available",
  isProfessional: true,
  isVisible: true
};
